export default __webpack_public_path__ + "assets/images/b56942e498b0b668eca0cfdff9db6512.png";